/* eslint-disable no-classname/no-classname-outside-designsystem */
import { Button } from 'designSystem/components/Button'
import { cn } from 'designSystem/lib/utils'
import * as React from 'react'

export type ToolbarToggleOption<T> = {
  value: T
  label: React.ReactNode
  disabled?: boolean
}

/**
 * Segmented two/N-option control for the asset-viz overlay toolbar (e.g. the
 * in/mm units toggle and the 2D/3D view-mode toggle). Owns the glass-blur group
 * markup and per-option button styling so each toggle is a declarative usage
 * rather than a hand-rolled button group.
 */
export function AssetVizToolbarToggle<T>({
  ariaLabel,
  options,
  value,
  onChange,
}: {
  ariaLabel: string
  options: readonly ToolbarToggleOption<T>[]
  value: T
  onChange: (value: T) => void
}) {
  return (
    <div
      className='inline-flex shrink-0 rounded-md border border-border/80 bg-background/85 p-px shadow-sm backdrop-blur-sm'
      role='group'
      aria-label={ariaLabel}>
      {options.map((option) => {
        const selected = option.value === value
        return (
          <Button
            key={String(option.value)}
            type='button'
            variant={selected ? 'secondary' : 'ghost'}
            size='sm'
            className={cn(
              'h-5 min-w-7 rounded-sm px-1.5',
              selected && 'shadow-none'
            )}
            aria-pressed={selected}
            disabled={option.disabled}
            onClick={() => onChange(option.value)}>
            {option.label}
          </Button>
        )
      })}
    </div>
  )
}
